<template>
  <div class="backStack-issue-wrap operationIssue">
    <From
      ref="formRef"
      layoutType="grid"
      :isErrorMessage="false"
      :optionList="formRows"
      :formRules="formRules"
      :defaultModel="defaultModel"
      @updateForm="updateForm"
    >
    </From>
    <UserInfos
      ref="userInfos"
      :infos="userInfo"
      @selectChange="selectChange"
    ></UserInfos>
    <div class="backStack-issue-footer-wrap">
      <div class="read-wrap">
        <a-checkbox @change="readChange"></a-checkbox>
        <span class="text">我已阅读并同意《开放许可信息发布规则》</span>
      </div>
      <div class="submit-wrap">
        <a-button class="submit-audit" @click="toAudit">提交审核</a-button>
        <span class="text"
          >温馨提示：开放许可信息提交后，将由相关人员审核后，方可发布！</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import From from '../../components/formTable/form.vue'
import UserInfos from '../../components/userInfos/index.vue'
import mixinsBackStack from '@/mixins/backStack'
import { formRules, formRows, userInfo } from './configs/formOptions.js'
import { editLience, getLicenceDetail } from '@/api/licenceInfo.js'

export default {
  mixins: [mixinsBackStack],
  data() {
    return {
      loading: true,
      userInfo, // 用户信息假数据
      formRows, // 表单item配置
      formRules, // 表单校验规则配置
      defaultModel: {
        publicNum: '',
        applyNum: '',
        legalStatus: '',
        patentName: '',
        patentType: ''
      },
      isRead: false,
      detailId: null,
      selectValue: ''
    }
  },
  components: {
    From,
    UserInfos
  },
  created() {
    this.initSetting()
  },
  methods: {
    selectChange(val) {
      this.selectValue = val
    },
    // 初始化数据
    initSetting() {
      const { id } = this.$route.query
      this.detailId = id
      this.initDefaultModel()
    },
    // 获取默认值
    async initDefaultModel() {
      const { data } = await getLicenceDetail(this.detailId)
      if (data.orgType) {
        data.user.orgTypeStr = data.orgType
      }
      this.defaultModel = { ...data }

      console.log(this.defaultModel)
      this.dealInfo('userInfo', data.user) // 处理用户信息
    },
    // 公开号检索
    updateForm(searchV) {
      const {
        inputValue,
        priceRange,
        ...curFormModal
      } = this.$refs.formRef.formModel
      let other =
        priceRange === -1
          ? { priceRange: -1 }
          : { priceRange: inputValue || priceRange }
      this.defaultModel = Object.assign(curFormModal, searchV, other)
    },
    // 处理静态信息
    dealInfo(type, result) {
      if (!result) return
      if (!this[type]) return
      this[type].forEach(item => {
        const { key } = item
        const v = result[key] || '-'
        item.value = v
      })
    },
    readChange(e) {
      const { target } = e
      this.isRead = target.checked
    },
    // 参数处理
    beforeRequest() {
      const { detailId } = this
      const { inputValue, ...formValue } = this.$refs.formRef.formModel
      const userInfo = this.$refs.userInfos.model
      let params = { ...formValue, ...userInfo, id: detailId }
      params.orgType = this.selectValue
      if (inputValue) {
        // 单独处理自定义radio勾选框中的值
        params.priceRange = inputValue
      }
      return params
    },
    async toAudit() {
      const v = this.$refs.formRef.validatedForm(undefined, function(
        formModal
      ) {
        console.log(formModal)
        if (formModal.inputValue === undefined && formModal.priceRange !== -1) {
          this.$apiStatusHandler(99, '预算金额不能为空')
          return false
        }
        return true
      })
      if (!v) return
      if (!this.isRead) {
        return this.$apiStatusHandler(1, '请勾选《开放许可信息发布规则》')
      }
      const params = this.beforeRequest()
      const { msg, code } = await editLience(params)
      this.$apiStatusHandler(code, msg)
      this.$router.push({
        name: 'licenceInfos',
        query: { key: 'licenceInfos' }
      })
    }
  }
}
</script>
